'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";

/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconPlaybackSpeed3x/index.tsx)
 */
export function IconPlaybackSpeed3x(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'m13.56 10.883 1.97-1.97-1.06-1.06-1.97 1.969-1.97-1.97-1.06 1.06 1.97 1.97-1.97 1.97 1.06 1.06 1.97-1.969 1.97 1.97 1.06-1.06-1.97-1.97Zm-9.465 3.373a5.255 5.255 0 0 1-2-.384c-.62-.267-1.067-.57-1.344-.912v-1.808c.288.49.736.89 1.344 1.2a4.168 4.168 0 0 0 1.856.448c.49 0 .922-.085 1.296-.256a1.92 1.92 0 0 0 .848-.768c.202-.33.304-.72.304-1.168 0-.683-.251-1.2-.752-1.552-.491-.363-1.27-.544-2.336-.544h-.448V7.488L5.93 4H.943V2.64h6.704v1.44L4.67 7.441c1.027.108 1.827.438 2.4.991.618.576.928 1.339.928 2.288 0 .64-.166 1.232-.496 1.776a3.6 3.6 0 0 1-1.392 1.28c-.587.32-1.26.48-2.016.48Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'m19.742 16.75 2.543-2.543-1.414-1.414-2.543 2.543-2.543-2.543-1.414 1.414 2.543 2.543-2.543 2.543 1.414 1.414 2.543-2.543 2.543 2.543 1.414-1.414-2.543-2.543ZM6.984 21.022c-.997 0-1.94-.184-2.829-.552-.89-.384-1.533-.82-1.932-1.311v-2.507c.414.705 1.05 1.28 1.91 1.725.873.429 1.762.644 2.667.644.72 0 1.35-.13 1.886-.391a2.84 2.84 0 0 0 1.265-1.127c.291-.491.437-1.058.437-1.702 0-1.012-.368-1.78-1.104-2.3-.72-.522-1.855-.782-3.404-.782h-.644v-1.426l4.478-5.106H2.499V4.324h9.568v1.978l-4.326 4.923c1.493.154 2.66.63 3.498 1.425.89.828 1.334 1.924 1.334 3.289 0 .92-.238 1.77-.713 2.553-.46.766-1.12 1.38-1.978 1.84-.843.46-1.81.69-2.898.69Z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconPlaybackSpeed3x is deprecated and will be archived soon. Use IconPlaybackSpeed3x instead.
 */
export function Experimental__IconPlaybackSpeed3x(props) {
  return /*#__PURE__*/React.createElement(IconPlaybackSpeed3x, props);
}